import { RouteConfig } from '@app/types';
import { CustomRouterLink } from './CustomRouterLink';
import style from './NavMenu.module.scss';

type NavMenuProps<TPath extends string> = {
  routes: RouteConfig<TPath>[];
};

export function NavMenu<TPath extends string>({ routes }: NavMenuProps<TPath>) {
  return (
    <div className={style.container}>
      <ul className={style.menu}>
        {routes.map(({ path, label, tooltip }) => {
          return (
            <CustomRouterLink
              data-tip={tooltip}
              key={path}
              label={label}
              parentClassName={style.item}
              to={path}
            />
          );
        })}
      </ul>
    </div>
  );
}
